import Pui9HttpRequests from '@Pui9Requests';
import store from './store/store';
import puiEventsBus from './bus';
import i18n from './i18n/i18n';
import { setUserId } from './plugins/matomo';

export default async function beforeRun() {
	var session = store.getters.getSession;
	var userLogged = JSON.parse(window.localStorage.getItem(session.keepSessionAliveInfoKey));
	// Si no queremos login de pui, y ademÃ¡s no hay un usuario en sesiÃ³n...
	if (!store.getters.withLogin && !userLogged) {
		// si ademÃ¡s no estÃ¡ el usuario anonimo, hacemos el login
		if (!window.localStorage.getItem('anonymous_session')) {
			const loginResponse = await doAnonymousLogin();
			try {
				const loginInfo = loginResponse.data;
				if (loginInfo) {
					setLoginInfo(loginInfo);
					puiEventsBus.$emit('onPuiLoginSignin', loginInfo);
					// save token
					window.localStorage.setItem('anonymous_session', JSON.stringify(loginInfo));
				}
			} catch (error) {
				console.log(error);
			}
		} else {
			const userAnonymous = JSON.parse(window.localStorage.getItem('anonymous_session'));
			// Si estÃ¡ el usuario anonimo, lo metemos en el state
			this.setLoginInfo(userAnonymous);
			puiEventsBus.$emit('onPuiLoginSignin', userAnonymous);
			store.commit('setAnonymousToken', userAnonymous.jwt);
		}
	} else if (userLogged) {
		const pui9Lang = window.localStorage.getItem('pui9_lang');
		if (pui9Lang && pui9Lang !== userLogged.language) {
			userLogged.language = pui9Lang;
			window.localStorage.setItem(session.keepSessionAliveInfoKey, JSON.stringify(userLogged));
		}
		setLoginInfo(userLogged);
		puiEventsBus.$emit('onPuiLoginSignin', userLogged);
		store.commit('setAnonymousToken', userLogged.jwt);

		window.addEventListener('load', event => {
			console.log(event);
			var minilogoElement = document.getElementsByClassName('puimenu-leftBar__logo-img')[0];
			var entorno = JSON.parse(window.localStorage.getItem('distributionAppData'));
			if (entorno.minilogo && minilogoElement) {
				minilogoElement.setAttribute(
					'style',
					"background:url('data:image/png;base64, " + entorno.minilogo + "') no-repeat center !important; opacity: 1;"
				);
			}
		});
	}
}

async function doAnonymousLogin(succes, error) {
	const loginConfig = store.getters.getLoginConfig;
	const params = {
		usr: loginConfig.anonymousUser,
		password: loginConfig.anonymousPass,
		client: store.getters.clientName,
		persistent: true
	};
	const response = await Pui9HttpRequests.postRequest('/login/signin', params, succes, error);
	return response;
}

function setLoginInfo(loginInfo) {
	//first commit the login info, the language will be set applying some logic
	store.commit('puiLoginSetInfo', loginInfo);
	const sessionKey = store.getters.getSession.keepSessionAliveInfoKey; // Obtener clave de sesión
	window.localStorage.setItem(sessionKey, JSON.stringify(loginInfo));

	//then we use the language saved, not the recieved
	const lang = store.getters.getUserLanguage;

	i18n.locale = lang;
	window.localStorage.setItem('pui9_lang', lang);
	store.commit('setUserLanguage', lang);
	store.commit('setHttpRequestHeaders', { authorization: loginInfo.jwt, acceptLanguage: lang });
	setUserId(loginInfo.usr);
}
